import { ClockIcon, CurrencyDollarIcon, MapPinIcon, UserGroupIcon } from "@heroicons/react/24/outline"
import React from "react"
import { twMerge } from "tailwind-merge"

import { bookableEventTypeDisplayAmount } from "../../@core/bookableEventType/bookableEventType.utils"

const BookableEventTypeDetails = ({ bookableEventType, practice, theme, className }) => {
  const formatDuration = (duration, durationUnit) => {
    if (!duration) return "Duration not set"
    if (durationUnit === "minute") return duration === 1 ? `${duration} Minute` : `${duration} Minutes`
    if (durationUnit === "hour") return duration === 1 ? `${duration} Hour` : `${duration} Hours`
    if (durationUnit === "day") return duration === 1 ? `${duration} Day` : `${duration} Days`
  }

  const getCapacityText = () => {
    const capacity = bookableEventType.capacity
    if (!capacity) return "Unlimited"
    if (capacity === 1) return "1 Person"
    return `${capacity} People`
  }

  const getLocationText = () => {
    if (bookableEventType.kind === "in_person") return "In-person"
    if (bookableEventType.kind === "virtual") return "Virtual"
    return "Location TBD"
  }

  // Support both v1 (colorAccent) and v2 (colors.accent) theme structures
  // Use primary color for icons instead of accent color
  const accentColor =
    theme?.colors?.primary || theme?.colorPrimary || theme?.colors?.accent || theme?.colorAccent || "#DF0054"
  const textDarkColor = theme?.colors?.textDark || theme?.colorTextDark || "#454A4F"

  const details = [
    {
      icon: <CurrencyDollarIcon className="h-10 w-10" style={{ color: accentColor || "#DF0054" }} />,
      value: bookableEventTypeDisplayAmount(bookableEventType, practice.defaultCurrency),
      label: "Price"
    },
    {
      icon: <ClockIcon className="h-10 w-10" style={{ color: accentColor || "#DF0054" }} />,
      value: formatDuration(bookableEventType.duration, bookableEventType.durationUnit),
      label: "Duration"
    },
    {
      icon: <UserGroupIcon className="h-10 w-10" style={{ color: accentColor || "#DF0054" }} />,
      value: getCapacityText(),
      label: "Capacity"
    },
    {
      icon: <MapPinIcon className="h-10 w-10" style={{ color: accentColor || "#DF0054" }} />,
      value: getLocationText(),
      label: "Location"
    }
  ]

  return (
    <div className={twMerge("", className)}>
      <div className="grid grid-cols-2 gap-6 min_md:grid-cols-4">
        {details.map((detail, index) => (
          <div
            key={index}
            className="flex flex-col items-center rounded-lg border border-gray-light bg-white p-6 text-center">
            <div className="mb-3">{detail.icon}</div>
            <div className="mb-1 text-xl font-bold" style={{ color: textDarkColor }}>
              {detail.value}
            </div>
            <div className="text-sm" style={{ color: textDarkColor }}>
              {detail.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default BookableEventTypeDetails
